import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { SmallContainer } from 'app/components/common/container';
import { Paper } from 'app/components/common/paper';
import { RootActions, RootState } from 'app/redux';
import { updateActivationDateActionCreator } from 'app/page/orders/redux/orders-action-creators';
import { UpdateActivationDateForm } from 'app/page/orders/update-activation-date/update-activation-date-form';
import { UpdateActivationDateFormModel } from 'app/page/orders/update-activation-date/update-activation-date-form-model';
import { UPDATE_ACTIVATION_DATE_FORM_FIELDS } from 'app/page/orders/update-activation-date/update-activation-date-form-fields';
import { OrderUtils } from 'app/page/orders/utils/order-utils';
import { FormName } from 'app/page/orders/form-name';
import { BillingAccountUtils } from 'app/page/orders/utils/billing-account-utils';
import { BillingAccount } from 'app/page/orders/model/billing-account';

interface StateProps {
    billingAccounts: BillingAccount[];
    selectedBillingAccountId?: string;
}

interface DispatchProps {
    updateActivationDate: typeof updateActivationDateActionCreator;
}

type Props = StateProps & DispatchProps;

class UpdateActivationDatePageComponent extends React.Component<Props> {
    public render(): React.ReactNode {
        const { billingAccounts, selectedBillingAccountId, updateActivationDate } = this.props;

        if (!selectedBillingAccountId) {
            throw new Error('Billing account must be selected.');
        }

        const selectedBillingAccount = BillingAccountUtils.getBillingAccount(billingAccounts, selectedBillingAccountId);

        const { activeOrders, selectedOrderId } = selectedBillingAccount;

        if (!selectedOrderId) {
            throw new Error('Order must be selected.');
        }

        const activationDate = OrderUtils.getActivationDate(activeOrders[selectedOrderId]);

        const initialValues: Partial<UpdateActivationDateFormModel> = {
            [UPDATE_ACTIVATION_DATE_FORM_FIELDS.activationDate]: activationDate,
        };

        return (
            <SmallContainer>
                <Paper>
                    <UpdateActivationDateForm
                        form={FormName.UPDATE_ACTIVATION_DATE}
                        initialValues={initialValues}
                        onSubmit={updateActivationDate}
                    />
                </Paper>
            </SmallContainer>
        );
    }
}

const mapStateToProps = (state: RootState): StateProps => {
    const {
        orders: { billingAccounts, selectedBillingAccountId },
    } = state;

    return {
        billingAccounts,
        selectedBillingAccountId,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootActions>): DispatchProps => ({
    ...bindActionCreators(
        {
            updateActivationDate: updateActivationDateActionCreator,
        },
        dispatch,
    ),
});

const UpdateActivationDatePage = connect(mapStateToProps, mapDispatchToProps)(UpdateActivationDatePageComponent);

export { UpdateActivationDatePage };
